<template>
  <div>
    <div class="text-caption grey--text mb-2">
      Calculado automaticamente a partir da grade de dias e horários, descontando feriados e sábados
      não letivos.
    </div>

    <p v-if="matriz.componentes.length === 0" class="text-center grey--text pa-4">
      Nenhum componente curricular vinculado ainda.
    </p>

    <div v-else style="overflow-x: auto">
      <table class="tabela-aulas-etapa" style="width: 100%; border-collapse: collapse">
        <thead>
          <tr>
            <th class="text-left text-caption grey--text pa-2" style="min-width: 160px">
              Componente
            </th>
            <th
              v-for="etapa in matriz.etapas"
              :key="etapa.id"
              class="text-center text-caption grey--text pa-2"
              style="min-width: 90px"
            >
              {{ etapa.descricao }}
              <div class="text-caption grey--text" style="font-weight: normal">
                {{ formatarPeriodo(etapa) }}
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="componente in matriz.componentes"
            :key="componente.id"
            style="border-top: 1px solid rgba(0, 0, 0, 0.06)"
          >
            <td class="pa-2">
              <v-chip x-small :color="corDoComponente(componente.id)" dark>
                {{ componente.descricao }}
              </v-chip>
            </td>
            <td
              v-for="etapa in matriz.etapas"
              :key="etapa.id"
              class="text-center pa-2"
              :class="{ 'grey--text': !componente.por_etapa[etapa.id] }"
            >
              {{ componente.por_etapa[etapa.id] || 0 }}
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr style="border-top: 2px solid rgba(0, 0, 0, 0.12)">
            <td class="pa-2 font-weight-bold">Total</td>
            <td
              v-for="etapa in matriz.etapas"
              :key="etapa.id"
              class="text-center pa-2 font-weight-bold"
            >
              {{ etapa.total }}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "ETabelaAulasPorEtapa",
  props: {
    matriz: {
      type: Object,
      required: true,
    },
    componentesCores: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    corDoComponente(disciplinaId) {
      const componente = this.componentesCores.find((c) => c.id === disciplinaId);
      return componente ? componente.cor : "grey";
    },
    formatarPeriodo(etapa) {
      if (!etapa.periodo_inicial || !etapa.periodo_final) return "";
      const formatar = (data) => data.split("-").reverse().slice(0, 2).join("/");
      return `${formatar(etapa.periodo_inicial)} - ${formatar(etapa.periodo_final)}`;
    },
  },
};
</script>
